// src/pages/Private/Teacher/CourseManagement/CourseModules.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../../../utils/axios';
import './CourseModules.css';

function CourseModules() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAddModule, setShowAddModule] = useState(false);
  const [newModule, setNewModule] = useState({ title: '', description: '', order: 1 });

  useEffect(() => {
    loadCourseData();
  }, [courseId]);

  const loadCourseData = async () => {
    try {
      const [courseRes, modulesRes] = await Promise.all([
        axios.get(`/courses/${courseId}`),
        axios.get(`/modules/course/${courseId}`)
      ]);
      setCourse(courseRes.data);
      setModules(modulesRes.data);
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddModule = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/modules', {
        courseId,
        ...newModule
      });
      setModules([...modules, response.data]);
      setShowAddModule(false);
      setNewModule({ title: '', description: '', order: modules.length + 1 });
    } catch (error) {
      console.error('Modül eklenirken hata:', error);
    }
  };

  const handleDeleteModule = async (moduleId) => {
    if (!window.confirm('Bu modülü silmek istediğinizden emin misiniz?')) return;
    
    try {
      await axios.delete(`/modules/${moduleId}`);
      setModules(modules.filter(m => m._id !== moduleId));
    } catch (error) {
      console.error('Modül silinirken hata:', error);
    }
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="course-modules">
      <div className="modules-header">
        <div>
          <h1>{course?.title} - Modüller</h1>
          <p className="course-desc">{course?.description}</p>
        </div>
        <button 
          className="btn-primary"
          onClick={() => setShowAddModule(true)}
        >
          + Yeni Modül
        </button>
      </div>

      {showAddModule && (
        <div className="modal">
          <div className="modal-content">
            <h3>Yeni Modül Ekle</h3>
            <form onSubmit={handleAddModule}>
              <div className="form-group">
                <label>Modül Başlığı</label>
                <input
                  type="text"
                  value={newModule.title}
                  onChange={(e) => setNewModule({...newModule, title: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Açıklama</label>
                <textarea
                  value={newModule.description}
                  onChange={(e) => setNewModule({...newModule, description: e.target.value})}
                  rows="3"
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-success">Kaydet</button>
                <button type="button" className="btn-cancel" onClick={() => setShowAddModule(false)}>İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="modules-list">
        {modules.length === 0 ? (
          <div className="empty-state">
            <p>Henüz modül eklenmemiş. İlk modülü ekleyin!</p>
          </div>
        ) : (
          modules.map((module, index) => (
            <div key={module._id} className="module-card">
              <div className="module-header">
                <div>
                  <h3>Modül {index + 1}: {module.title}</h3>
                  <p>{module.description}</p>
                </div>
                <div className="module-actions">
                  <button 
                    className="btn-edit"
                    onClick={() => navigate(`/teacher/module/${module._id}/lessons`)}
                  >
                    Dersleri Yönet
                  </button>
                  <button 
                    className="btn-delete"
                    onClick={() => handleDeleteModule(module._id)}
                  >
                    🗑️
                  </button>
                </div>
              </div>
              <div className="module-stats">
                <span>{module.lessons?.length || 0} ders</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default CourseModules;